/**
 * Origin of the public website, used as the postMessage `targetOrigin` for the
 * embedded claim surfaces and for outbound links (e.g. `/contact`). Single
 * source of the env fallback chain so the website<->iframe handshake and links
 * can't drift per page.
 */
export function getWebsiteOrigin(): string {
  return new URL(
    import.meta.env.VITE_WEBSITE_URL || import.meta.env.VITE_PUBLIC_SITE_URL || 'https://shopexperts.com',
    window.location.origin,
  ).origin;
}

export function resolveEmbedParentOrigin(candidate: unknown): string {
  const fallback = getWebsiteOrigin();
  if (typeof candidate !== 'string' || !candidate) return fallback;

  let parsed: URL;
  try {
    parsed = new URL(candidate);
  } catch {
    return fallback;
  }
  if (parsed.origin !== candidate) return fallback;

  const isShopexperts = parsed.protocol === 'https:'
    && (parsed.hostname === 'shopexperts.com' || parsed.hostname.endsWith('.shopexperts.com'));
  const isLocalDev = import.meta.env.DEV
    && (parsed.hostname === 'localhost' || parsed.hostname === '127.0.0.1');

  return isShopexperts || isLocalDev ? parsed.origin : fallback;
}
